<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      :class="$vuetify.breakpoint.smAndDown ? 'padding-b' : 'pb-12'"
      maxwidth-container="820px"
    >
      <v-breadcrumbs
        v-if="$vuetify.breakpoint.mdAndUp"
        v-model="menus"
        :items="menus"
        class="pl-0 mt-6"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled"
            class="body-2"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <TituloPagina
        :titulo="tituloPagina"
        class="mt-7 mt-md-5"
      />

      <template v-if="loading">
        <template v-for="index in 6">
          <v-skeleton-loader
            :key="`item-${index}`"
            class="mx-auto my-5"
            type="text"
          />
        </template>
      </template>

      <ListaMotivos
        v-else
        :lista="listaMotivos"
        :mostrar-outros="mostrarOutros"
        :proxima-pagina="proximaPagina"
        class="mt-md-5 mb-md-10"
      />

      <BtnVoltar
        v-if="$vuetify.breakpoint.smAndDown"
        :voltar-para="urlVoltar"
        max-width="800px"
      />
      <v-btn
        v-if="$vuetify.breakpoint.mdAndUp && !loading"
        class="mt-10"
        color="primary"
        data-cy="btn_voltar"
        outlined
        width="278"
        @click="$router.go(-1)"
      >
        Voltar
      </v-btn>
    </InternaMain>
  </Wrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ListaMotivos from '@/components/NaoEncontrei/ListaMotivos.vue';

export default {
  name: 'Motivos',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    BtnVoltar,
    TituloPagina,
    ListaMotivos,
  },

  props: {
    tituloPagina: {
      type: String,
      default: '',
    },
    urlApi: {
      type: String,
      default: '',
    },
    footer: {
      type: Boolean,
      default: true,
    },
    limite: {
      type: Number,
      default: 0,
    },
    mostrarOutros: {
      type: Boolean,
      default: false,
    },
    proximaPagina: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: true,
      listaMotivos: [],
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    menus() {
      return [
        {
          text: 'Minhas Compras',
          disabled: false,
          href: '/minhas-compras/',
        },
        {
          text: 'Acompanhar solicitação',
          disabled: false,
          href: this.urlAcompanharSolicitacao,
        },
        {
          text: 'Discordo do vendedor',
          disabled: true,
        },
      ];
    },

    urlAcompanharSolicitacao() {
      const { codigoReembolso } = this.dadosCompra;
      const { venda } = this.dadosCompra;

      return `/acompanhar-solicitacao-reembolso/${venda}/${codigoReembolso}`;
    },
  },

  created() {
    this.carregarListaMotivos();
  },

  methods: {
    async carregarListaMotivos() {
      await api.get(this.urlApi)
        .then((response) => {
          let motivos = response.data;
          if (motivos.length && this.limite) {
            motivos = motivos.slice(0, this.limite);
          }
          this.$store.dispatch('setMotivosReembolso', motivos.slice(this.limite));
          this.listaMotivos = motivos;
        })
        .catch(() => {
          this.motivos = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },


};
</script>

<style lang="scss" scoped>
.padding-b { padding-bottom: 70px !important; }
</style>
